module.exports = __webpack_public_path__ + "img/proj4-epicurator.3b84b61f.png";